// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddToJobFolderModalSkeleton {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  flex: 1 1;
}

.JobFolderAccordionSkeleton {
  padding: 0 32px;
}
.JobFolderAccordionSkeleton .JobFolderAccordionTitleSkeleton {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  padding: 8px 0;
}
.JobFolderAccordionSkeleton .JobFolderAccordionHeaderSkeleton {
  display: flex;
  align-items: center;
  justify-content: space-between;
  row-gap: 5px;
}
.JobFolderAccordionSkeleton .JobFolderAccordionBodySkeleton {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding-left: 22px;
  margin-top: 8px;
}
.JobFolderAccordionSkeleton .JobFolderAccordionFooterSkeleton {
  display: flex;
  column-gap: 4px;
  padding: 18px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/AddToJobFolderModal/components/AddToJobFolderModalSkeleton/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAIE;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAFJ","sourcesContent":[".AddToJobFolderModalSkeleton {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n  flex: 1;\n}\n\n.JobFolderAccordionSkeleton {\n  padding: 0 32px;\n\n  .JobFolderAccordionTitleSkeleton {\n    display: flex;\n    flex-direction: column;\n    row-gap: 5px;\n    padding: 8px 0;\n  }\n\n  .JobFolderAccordionHeaderSkeleton {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    row-gap: 5px;\n  }\n\n  .JobFolderAccordionBodySkeleton {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n    padding-left: 22px;\n    margin-top: 8px;\n  }\n\n  .JobFolderAccordionFooterSkeleton {\n    display: flex;\n    column-gap: 4px;\n    padding: 18px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
